import React from 'react';
import styles from './AuthorizedContentContainer.module.scss';

const AuthorizedContentContainer = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default AuthorizedContentContainer;
